import { styled } from "@mui/material";

export const NoPrintFlex = styled("div")({
  display: "flex",
  flex: "1",
  "@media print": {
    display: "none",
  },
});
